import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { createApi } from "@reduxjs/toolkit/query/react";
import type {
    CloneChatConversationRequest,
    CloneChatConversationResponse,
    DeleteAdminChatConversationMessageRequest,
    DeleteAdminChatConversationMessageResponse,
    ListAdminChatConversationMessagesRequest,
    ListAdminChatConversationMessagesResponse,
    ListAdminChatConversationsRequest,
    ListAdminChatConversationsResponse
} from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminChatConversationApi = createApi({
    reducerPath: "adminChatConversationApi",
    baseQuery: baseQueryAdminWithAuth,
    tagTypes: ["Conversations", "ConversationMessages"],
    endpoints: builder => ({
        listAdminChatConversations: builder.query<ListAdminChatConversationsResponse, ListAdminChatConversationsRequest>({
            query: body => ({
                url: `chatconversation/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            }),
            providesTags: ["Conversations"]
        }),
        listAdminChatConversationMessages: builder.query<ListAdminChatConversationMessagesResponse, ListAdminChatConversationMessagesRequest>({
            query: body => ({
                url: `chatconversation/messages/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            }),
            providesTags: (_result, _error, request) => [
                { type: "ConversationMessages", id: request.chat_conversation_id }
            ]
        }),
        cloneChatConversation: builder.mutation<CloneChatConversationResponse, CloneChatConversationRequest>({
            query: body => ({
                url: "chatconversation/clone",
                method: "POST",
                body
            }),
            invalidatesTags: ["Conversations"]
        }),
        deleteAdminChatConversationMessage: builder.mutation<DeleteAdminChatConversationMessageResponse, DeleteAdminChatConversationMessageRequest>({
            query: body => ({
                url: "chatconversation/messages/delete",
                method: "POST",
                body
            }),
            invalidatesTags: (_result, _error, request) => [
                "Conversations",
                { type: "ConversationMessages", id: request.chat_conversation_id }
            ]
        })
    })
});

export const {
    useCloneChatConversationMutation,
    useDeleteAdminChatConversationMessageMutation,
    useListAdminChatConversationsQuery,
    useListAdminChatConversationMessagesQuery
} = adminChatConversationApi;
